"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResponsive = exports.breakpointsValues = exports.getIsPortraitOrientation = void 0;
var objectKeys_1 = require("tsafe/objectKeys");
var ViewPortAdapter_1 = require("powerhooks/ViewPortAdapter");
Object.defineProperty(exports, "getIsPortraitOrientation", { enumerable: true, get: function () { return ViewPortAdapter_1.getIsPortraitOrientation; } });
exports.breakpointsValues = {
    "sm": 600,
    "md": 960,
    "lg": 1280,
    "xl": 1920,
};
exports.createResponsive = (function () {
    var getNextBreakpoint = (function () {
        var ascendingOrderedBreakpoints = objectKeys_1.objectKeys(exports.breakpointsValues).sort(function (bpA, bpB) { return exports.breakpointsValues[bpA] - exports.breakpointsValues[bpB]; });
        function getNextBreakpoint(breakpoint) {
            return ascendingOrderedBreakpoints[ascendingOrderedBreakpoints.indexOf(breakpoint) + 1];
        }
        return { getNextBreakpoint: getNextBreakpoint };
    })().getNextBreakpoint;
    function createResponsive(params) {
        var windowInnerWidth = params.windowInnerWidth;
        var out = {
            "up": function (arg) {
                return windowInnerWidth >=
                    (typeof arg === "number" ? arg : exports.breakpointsValues[arg]);
            },
            "down": function (arg) { return !out.up(arg); },
            "between": function (start, end) { return out.up(start) && out.down(end); },
            "only": function (breakpoint) {
                var _a;
                return out.between(breakpoint, (_a = getNextBreakpoint(breakpoint)) !== null && _a !== void 0 ? _a : Infinity);
            },
            windowInnerWidth: windowInnerWidth,
        };
        return out;
    }
    return { createResponsive: createResponsive };
})().createResponsive;
//# sourceMappingURL=responsive.js.map